import { useContext, useEffect } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { BannerType, BannerView } from "@dotnet/telematics-design-system";

import { FILE_NAME } from "components/Actions/dialogs/Devices/types";
import SampleTemplate from "components/DesignComponents/SampleTemplate";
import Dropzone from "components/Dropzone";
import DropzoneContext from "context/dropzone/dropzoneContext";
import TriSourceContext from "context/triSource/triSourceContext";
import { TRI_SOURCES } from "shared/types/enums";

import { FromFileProps } from "../types";

const FromFile = ({
    deviceId,
    isLoading,
    description,
    setCount
}: FromFileProps) => {
    const { lineCount } = useContext(DropzoneContext);
    const { handleNeedConfirmation } = useContext(TriSourceContext);

    const { t } = useTranslation();

    // Check if confirmation is required
    useEffect(() => {
        handleNeedConfirmation(lineCount > 20);
        setCount?.(lineCount);
    }, [lineCount, handleNeedConfirmation, setCount]);

    return (
        <div data-testid={`tri-source-${TRI_SOURCES.FromFile}`}>
            <BannerView
                bannerType={BannerType.Info}
                title={t(
                    `Dialog##tri source##from file tab description##${description}`
                )}
                css={css({ marginBottom: "16px" })}
            />

            {deviceId}

            <Dropzone
                supportedFormats={[".csv"]}
                isLoading={isLoading}
                countCsv
            />

            <SampleTemplate fileName={FILE_NAME.SampleImeiList} />
        </div>
    );
};

export default FromFile;
